export const getColor = (status?: string) => {
  if (status === "unpaid") return "blue-200";
  return "green-500";
};
